import first from "./js/first.js";
import second from "./js/second.js";
import third from "./js/third.js";
import fourth from "./js/fourth.js"